export default {
  refunded: {
    id: 'sav_platform_refunded',
    defaultMessage: 'Refunded',
  },
  cancelled: {
    id: 'sav_platform_cancelled',
    defaultMessage: 'Canceled',
  },
  shipped: {
    id: 'sav_platform_shipped',
    defaultMessage: 'Shipped',
  },
  validated: {
    id: 'sav_platform_validated',
    defaultMessage: 'Validated',
  },
  paid: {
    id: 'sav_platform_paid',
    defaultMessage: 'Paid',
  },
  productReturnPickedUp: {
    id: 'sav_platform_product_return_picked_up',
    defaultMessage: 'Product return - Shipped to merchant',
  },
  deliveredToTheFactory: {
    id: 'asp_product_return_delivered_to_the_factory',
    defaultMessage: 'Product return - Delivered to the factory',
  },
  deliveredToTheSeller: {
    id: 'sav_platform_product_return_delivered',
    defaultMessage: 'Product return - Delivered to the merchant',
  },
  returnProductReturnCreated: {
    id: 'sav_platform_return_product_return_created',
    defaultMessage: 'Product return - To be re-shipped to the customer',
  },
  returnProductReturnPickedUp: {
    id: 'sav_platform_return_product_return_picked_up',
    defaultMessage: 'Product return - Re-shipped to the customer',
  },
  returnProductReturnDelivered: {
    id: 'sav_platform_return_product_return_delivered',
    defaultMessage: 'Product return - Delivered to the customer',
  },
  repairCreated: {
    id: 'sav_platform_summary_tag_repair_created',
    defaultMessage: 'Repair status — repair request created',
  },
  repairReceived: {
    id: 'sav_platform_summary_tag_repair_received',
    defaultMessage: 'Repair status — received at the workshop',
  },
  repairDeviceLocked: {
    id: 'sav_platform_summary_tag_repair_device_locked',
    defaultMessage: 'Repair status — device locked',
  },
  repairDeviceUnlocked: {
    id: 'sav_platform_summary_tag_repair_device_unlocked',
    defaultMessage: 'Repair status — device unlocked',
  },
  repairOutOfWarranty: {
    id: 'sav_platform_summary_tag_repair_out_of_warranty',
    defaultMessage: 'Repair status — out of warranty',
  },
  repairRepaired: {
    id: 'sav_platform_summary_tag_repair_repaired',
    defaultMessage: 'Repair status — repaired',
  },
  repairNotRepaired: {
    id: 'sav_platform_summary_tag_repair_not_repaired',
    defaultMessage: 'Repair status — not repaired',
  },
  repairShippedToCustomer: {
    id: 'sav_platform_summary_tag_repair_shipped_to_customer',
    defaultMessage: 'Repair status — shipped back to the customer',
  },
  replacementOrder: {
    id: 'sav_platform_partnership_summary',
    defaultMessage: 'Replacement order',
  },
}
